export const SettingsActions = {
    FETCH_VIEWER_TYPE: 'FETCH_VIEWER_TYPE',
    FETCH_VIEWER_TYPE_RETURN: 'FETCH_VIEWER_TYPE_RETURN',
};

export const fetchViewerType = () => ({
    type: SettingsActions.FETCH_VIEWER_TYPE
});
export const fetchViewerTypeReturn = viewerType => ({
    type: SettingsActions.FETCH_VIEWER_TYPE_RETURN,
    payload: viewerType
});

